import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PageHeader, Skeleton } from '@/shared/ui';

/**
 * Экран, пока грузится чанк страницы (`lazyPage` в `app/router`). Без него
 * тап по «Свободной практике» на медленной сети показывал пустой белый экран,
 * пока не придёт код. Раскладка повторяет `TutorSelectPage`: шапка, карточка
 * 3:4 с краями соседей (масштаб и прозрачность — как у `TutorCarousel`),
 * имя, акцент и кнопка.
 */
export function TutorSelectPageSkeleton() {
  const { t } = useTranslation('TutorSelectPage');
  const navigate = useNavigate();

  return (
    <div aria-busy="true" className="flex h-dvh flex-col text-ink">
      <PageHeader title={t('headerTitle')} onBack={() => void navigate(-1)} />
      <div
        aria-hidden="true"
        className="h-[calc(var(--status-bar-top)+var(--header-band-height))] shrink-0"
      />

      <div className="flex w-full flex-1 flex-col items-center justify-center gap-8 px-4">
        <div className="flex w-full flex-col items-center gap-5">
          <div className="flex w-full justify-center overflow-hidden">
            {[0.86, 1, 0.86].map((scale, index) => (
              <div
                key={index}
                className="min-w-0 shrink-0 grow-0 basis-[76%] px-1.5"
                style={{ transform: `scale(${scale})`, opacity: scale < 1 ? 0.45 : 1 }}
              >
                {/* Скругление — обёрткой: `cn` не разрешает конфликт с `rounded-md` скелета. */}
                <div className="overflow-hidden rounded-[28px]">
                  <Skeleton className="aspect-[3/4] w-full" />
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col items-center gap-2">
            <Skeleton className="h-7 w-24" />
            <Skeleton className="h-4 w-28" />
          </div>
        </div>
      </div>

      <div className="shrink-0 px-5 pt-2 pb-[calc(var(--safe-bottom)+1rem)]">
        <div className="overflow-hidden rounded-full">
          <Skeleton className="h-14 w-full" />
        </div>
      </div>
    </div>
  );
}
